import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import { PHASE } from './constants';

/**
 * パスワード検証処理
 * @param {object} self this インスタンス
 */
export async function verifyPinNumber(self) {
  try {
    self.isLoading = true;
    const response = await individualWorkSupportUtil.postVerifyPinNumber(
      self,
      self.requirementId,
      self.systemId,
      {
        pin_number: self.inputData
      }
    );

    self.phase = response?.data?.verified ? PHASE.CONFIRM_CONSENT : PHASE.PASSWORD_MISMATCH;
  } finally {
    self.isLoading = false;
  }
}